// This file was automatically generated and should not be edited.
/* eslint-disable */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_seo_meditations_pranayama: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `<strong>Breathing Practices (Pranayama)</strong><br>Pranayama is the practice of working with the breath, often with a particular intention in mind (such as energizing or calming the mind and body). These practices will help you to become more aware of your breath and to sustain that awareness in daily life.`,
    es: `<strong>Prácticas de respiración (Pranayama)</strong><br>El pranayama es la práctica de trabajar con la respiración, a menudo con una intención particular en mente (como energizar o calmar la mente y el cuerpo). Estas prácticas te ayudarán a ser más consciente de tu respiración y a mantener esa conciencia en la vida diaria.`,
  };
  return phrases[locale] || phrases.en || 'seo_meditations_pranayama';
};
